<div class="page-layout blank p-24" fusePerfectScrollbar>
    <div class="">
        <h1>¡Bienvenido!</h1>
        <p class="lead">Signus Pasivos Exigibles</p>
    </div>

    <div *ngIf="!production">
        <h1>Estas en Modo desarrollo</h1>
        <button (click)="throwError()">Error</button>
        <button (click)="throwOtherError()">Other</button>
        <button (click)="throwHttpError()">HTTP</button>
    </div>
        
</div>